import React from 'react'

const Binance = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="22"
            fill="none"
            viewBox="0 0 23 22"
        >
            <path
                fill="#F3BA2F"
                d="M21.676 13.661c-1.47 5.893-7.438 9.48-13.331 8.01C2.452 20.2-1.133 14.233.337 8.34 1.805 2.446 7.774-1.14 13.666.328c5.893 1.47 9.479 7.439 8.01 13.332z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M11.007 6.981L8.16 9.83 6.502 8.172l4.505-4.505 4.507 4.507-1.657 1.657-2.85-2.85zM5.331 9.342L3.674 11l1.657 1.657L6.99 11 5.33 9.342zm2.828 2.829l2.848 2.848 2.85-2.85 1.658 1.657-4.508 4.507-4.505-4.505-.003-.003 1.66-1.654zm8.524-2.828l-1.657 1.658 1.657 1.657 1.658-1.657-1.658-1.658z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M12.688 11h.001l-1.682-1.683-1.243 1.243-.142.143-.295.294-.002.003.002.002 1.68 1.68 1.682-1.681.001-.001h-.002"
            ></path>
        </svg>
    )
}

export default Binance